import React, { useState } from 'react';
import {
  Box,
  Table,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  Typography,
  Divider,
  TableContainer
} from '@material-ui/core';
import useStyles from '../useStyles';
import Footer from './Footer';
import Row from './Row';
import RowDetails from './RowDetails';
import { toDecimal4 } from 'src/utils/toDecimal';
import CalculateDiscountsAndVAT from 'src/views/trans/JCdTrans/Inventory/calculateDiscountsAndVAT';

function Item({ ...item }) {
  const [showDetails, setShowDetails] = useState(false);

  function onToggleDetails(e) {
    e.preventDefault();
    e.stopPropagation();
    setShowDetails(prev => !prev);
  }

  return (
    <>
      <Row
        showDetails={showDetails}
        onToggleDetails={onToggleDetails}
        {...item}
      />
      <RowDetails showDetails={showDetails} {...item} />
    </>
  );
}

function Result({ items = [], columns = [], totals = {}, title = '' }) {
  const classes = useStyles();
  return (
    <Box>
      {title !== '' && (
        <Box>
          <Box p={2}>
            <Typography variant="h4" color="primary">
              {title}
            </Typography>
          </Box>
          <Divider />
        </Box>
      )}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell className={classes.profileCell} />
              {columns.map(column => (
                <TableCell
                  key={column?.key ?? column.fld}
                  style={{
                    width: column.width,
                    minWidth: column.width
                  }}
                  align={column?.align ?? 'left'}
                >
                  {column.caption}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {items.length === 0 && (
              <TableRow>
                <TableCell colSpan="100%" align="center">
                  No data to show
                </TableCell>
              </TableRow>
            )}
            {items.length > 0 &&
              items.map(item => (
                <Item key={item.ixTrans} columns={columns} {...item} />
              ))}
            {items.length > 0 && (
              <Footer columns={columns} totals={totals} length={items.length} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default Result;
